import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './KeyboardControls.module.css';
import { PLAYER_PLACEHOLDER_ID } from 'components/Player/Player';
interface ControlNodeProps {
  icon?: string;
  instructionText: string;
  label: string;
}
const UNICODE_ICONS = {
  RETURN: '\u23ce',
  SPACE: '\u2423',
  ARROW_UP: '\u2191',
  ARROW_DOWN: '\u2193',
  ARROW_RIGHT: '\u2192',
  ARROW_LEFT: '\u2190'
};
export const ROOT_ELEMENT_ID = 'keyboard-controls-root';
export const SIBLING_ELEMENT_ID = 'keyboard-controls-sibling';
const ControlNode = ({
  icon,
  instructionText,
  label
}: ControlNodeProps) => {
  return <>
      {icon ? <dt className={styles.descriptionTerm}>
          <kbd className={styles.keyboardInputElement}>{icon}</kbd>{' '}
          <span>{instructionText}:</span>
        </dt> : <dt className={styles.descriptionTerm}>
          <kbd className={styles.keyboardInputElement}>{instructionText}</kbd>
        </dt>}
      <dd className={styles.descriptionDetails}>{label}</dd>
    </>;
};
const PlayPauseNode = () => {
  return <>
      <dt className={styles.descriptionTerm}>
        <kbd className={styles.keyboardInputElement}>{UNICODE_ICONS.SPACE}</kbd>{' '}
        <span>Mellanslag,</span>
      </dt>
      <dt className={styles.descriptionTerm}>
        <kbd className={styles.keyboardInputElement}>
          {UNICODE_ICONS.RETURN}
        </kbd>{' '}
        <span>Retur:</span>
      </dt>
      <dd className={styles.descriptionDetails}>Spela / pausa programmet</dd>
    </>;
};
const PercentNode = () => {
  return <>
      <dt className={styles.descriptionTerm}>
        <kbd className={styles.keyboardInputElement}>0</kbd>
        {' - '}
        <kbd className={styles.keyboardInputElement}>9</kbd>
      </dt>
      <dd className={styles.descriptionDetails}>
        Hoppa direkt till 0% - 90% av programmets längd
      </dd>
    </>;
};
const KeyboardControls = () => {
  const [showControls, setShowControls] = useState(false);
  const [container] = useState(() => document.createElement('div'));
  useEffect(() => {
    const siblingDiv = document.getElementById(SIBLING_ELEMENT_ID);
    document.getElementById(ROOT_ELEMENT_ID)?.insertBefore(container, siblingDiv);
    return () => {
      if (document.getElementById(ROOT_ELEMENT_ID)?.contains(container)) {
        document.getElementById(ROOT_ELEMENT_ID)?.removeChild(container);
      }
    };
  }, [container]);
  const onFocus = () => {
    setShowControls(true);
  };
  const onBlur = (event: React.FocusEvent<HTMLElement>) => {
    setShowControls(event.currentTarget.contains(event.relatedTarget as HTMLElement));
  };
  return ReactDOM.createPortal(<nav className={classnames(styles.playerKeyboardControls, {
    [`${styles.showControls}`]: showControls
  })} onFocus={onFocus} onBlur={onBlur}>
      <p className={styles.heading}>Tangentbordskontroller för spelaren</p>

      <button className={styles.skipToPlayerButton} onClick={() => {
      setShowControls(false);
      document.getElementById(PLAYER_PLACEHOLDER_ID)?.focus();
    }}>
        Hoppa till spelaren
      </button>

      <dl className={styles.descriptionList}>
        <PlayPauseNode />

        <ControlNode instructionText="M" label="Ljud på / av" />

        <ControlNode icon={UNICODE_ICONS.ARROW_UP} instructionText="Pil upp" label="Höj ljudvolymen" />

        <ControlNode icon={UNICODE_ICONS.ARROW_DOWN} instructionText="Pil ned" label="Sänk ljudvolymen" />

        <ControlNode icon={UNICODE_ICONS.ARROW_RIGHT} instructionText="Pil höger" label="Hoppa framåt 5 sekunder" />

        <ControlNode icon={UNICODE_ICONS.ARROW_LEFT} instructionText="Pil vänster" label="Hoppa bakåt 5 sekunder" />

        <PercentNode />

        <ControlNode instructionText="C" label="Välj språk för undertextning" />

        <ControlNode instructionText="F" label="Visa spelaren i helskärmsläge" />

        <ControlNode instructionText="Esc" label="Avsluta helskärmsläge" />
      </dl>
    </nav>, container);
};
export default KeyboardControls;